export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'ap-annual-area';
export const REPORT_APE_ID = 'ap-annual-area-ape';
export const SLIDE_NUMBER = 10;
